// extracted by mini-css-extract-plugin
module.exports = {"zero-fundraiser":"fundraiser_skeleton__zero-fundraiser___tjS6y"};